import { Identifiable, Milestone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleEditRequest(
  milestone: Identifiable<Milestone>,
  { nextMilestone, milestone: m }: Boundaries["editMilestone"]["request"],
): Identifiable<Milestone> {
  return m.uuid === milestone.uuid
    ? { ...milestone, ...nextMilestone }
    : milestone;
}

function handleEditSuccess(
  milestone: Identifiable<Milestone>,
  {
    milestone: nextMilestone,
    impactedElements,
  }: Boundaries["editMilestone"]["success"],
): Identifiable<Milestone> {
  const impactedMilestone = impactedElements
    ? impactedElements.find(({ uuid }) => uuid === milestone.uuid)
    : undefined;

  return milestone.uuid === nextMilestone.uuid
    ? { ...milestone, ...nextMilestone }
    : !!impactedMilestone
      ? { ...milestone, ...impactedMilestone }
      : milestone;
}

function handleEditFailure(
  milestone: Identifiable<Milestone>,
  { milestone: m }: Boundaries["editMilestone"]["failure"],
): Identifiable<Milestone> {
  return m.uuid === milestone.uuid ? m : milestone;
}

export { handleEditRequest, handleEditSuccess, handleEditFailure };
